import { render, staticRenderFns } from "./DetailsBackup.vue?vue&type=template&id=a581a762&scoped=true&lang=pug"
import script from "./DetailsBackup.vue?vue&type=script&lang=js"
export * from "./DetailsBackup.vue?vue&type=script&lang=js"
import style0 from "./DetailsBackup.vue?vue&type=style&index=0&id=a581a762&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a581a762",
  null
  
)

export default component.exports